<template>
  <v-app :dark="true">
    <router-view>Login</router-view>
    <!-- setting drawer -->
    <!-- global snackbar -->
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      rightDrawer: false,
      snackbar: {
        show: false,
        text: '',
        color: '',
      },
    }
  },

  mounted() {
    let vm = this
    let token = this.$store.getters.getToken
    if (token) {
      this.$api.defaults.headers.common['Authorization'] = 'Bearer ' + token
    }

    this.$api.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (
          error &&
          error.response &&
          error.response.status &&
          (error.response.status === 401 || error.response.status === 403) &&
          vm.$route.name !== 'login'
        ) {
          delete vm.$api.defaults.headers.common['Authorization']
          vm.$store.commit('setUserData', null)
          vm.$store.commit('setToken', null)
          vm.$router.push({
            name: 'login',
          })
        }
        return Promise.reject(error)
      }
    )
  },
  created() {
    // add app events
    let vm = this
  },
  methods: {},
}
</script>

<style lang="sass" scoped>
.setting-fab
  top: 50% !important
  right: 0
  border-radius: 0
</style>
